import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  {
    label: 'Username',
    name: 'username',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'First Name',
    name: 'firstName',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  {
    label: 'Last Name',
    name: 'lastName',
    type: FIELD_TYPES.TEXT,
    defaultValue: '',
  },
  { label: 'UmbracoId', name: 'umbracoId', type: FIELD_TYPES.NUMBER, defaultValue: '' },
  {
    label: 'Roles',
    name: 'roles',
    type: FIELD_TYPES.ROLES_LIST,
    defaultValue: [],
  },
]
